// extracted by mini-css-extract-plugin
export default {"Title":"LoginCommon_Title__sg1iA","LoginInsteadText":"LoginCommon_LoginInsteadText__-cNEc"};